import React, { useEffect, useState } from 'react';
import fr from 'facet-rest';
import moment from 'moment-timezone';
import DataContainer from 'Components/UI/DataContainer';
import useCollection from 'Hooks/useCollection';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import PropTypes from 'prop-types';
import ProjectedMeetingsList from './ProjectedMeetingsList';

const ProjectedMeetingsContainer = ({ className }) => {
  const { householdResource } = useSimpleHousehold();
  const { collection: projectedMeetingsCollection, setCollection } = useCollection();

  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(null);

  const fetchProjectedMeetings = async (hhResource) => {
    try {
      const coll = await hhResource.relationship(fr.relationships.projectedMeetings.name)
        ?.link('related')
        .get({
          params: {
            tz: moment.tz.guess(),
            // limit: 3, // <---- ***** TODO: UNCOMMENT ME ONCE LIMIT IS SUPPORTED ON THE PROJECTED MEETING ENDPOINT *****
          },
        });
      setCollection(coll);
    } catch (err) {
      setLoadingError(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (householdResource) {
      fetchProjectedMeetings(householdResource);
    }
  }, [householdResource]);

  if (!householdResource.relationship(fr.relationships.projectedMeetings.name)) {
    return null;
  }

  return (
    <DataContainer
      backgroundColor="lightGray"
      loading={loading}
      loadingError={loadingError}
      ErrorListProps={{
        title: 'An error occurred while loading your projected meetings.',
      }}
      component={ProjectedMeetingsList}
      componentProps={{
        projectedMeetingsCollection,
        className,
      }}
    />
  );
};

ProjectedMeetingsContainer.defaultProps = {
  className: '',
};

ProjectedMeetingsContainer.propTypes = {
  className: PropTypes.string,
};

export default ProjectedMeetingsContainer;
